module.exports = __webpack_public_path__ + "static/sol2-d24c275e37f26757825483a9c6539923.png";